<template>
  <div class="p_ros_content">
    <div class="p_roster_table">
        <el-table v-loading="tableLoading" :max-height="tableHeight-100" :data="tableData" style="width:100%" stripe>
          <!-- <el-table-column align="center" label="序号" width="60px">
            <template slot-scope="scope">
                <span>{{(listQuery.currpage - 1) * listQuery.pagecount + scope.$index + 1}}</span>
              </template>
          </el-table-column> -->
          <template v-for="(item,index) in tableTitle">
             <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :width="item.StrColumName=='备注' ? 380 : (item.StrColumName=='NO'? 60 : (item.StrColumName=='姓名'? 100 : 200)) " align="center" :fixed="item.StrColumName=='项目名称' || item.StrColumName=='姓名'">
              <template slot-scope="{row}">
                <span v-if="item.StrColumName.indexOf('提前7天提醒')!=-1">{{isOverdue(7, row[item.StrColumId]) }}</span>
                <span v-else-if="item.StrColumName.indexOf('提前30天提醒')!=-1">{{ isOverdue(30, row[item.StrColumId]) }}</span>
                <span v-else-if="item.StrColumName.indexOf('提前60天提醒')!=-1">{{ isOverdue(60, row[item.StrColumId]) }}</span>
                <span v-else>{{row[item.StrColumId]}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="changeBPage"
            :current-page.sync="rosterQuery.currpage"
            :page-size="rosterQuery.perpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import xz from "@/common";
import moment from 'moment'
export default {
  name: "rosterList",
  props: {
    toChildrenData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data() {
    return {
      customVisible:false,
      // 业务部门
      departmentList:[],
      // 列表参数
      rosterQuery:{
        strorgancode:'',
        roletype:'',
        currpage: 1,
        perpage: 10,
        custname: '', // 项目名称
        username: '', // 姓名
        depname: '', // 归属业务部(业务立项部门)
        servicename: '', // 客服
        strWork: '', // 在离职状态
        strtel:'',//电话
        strjobtype:'',//岗位类别
        actualtype:'',//业务类型
        strDep1:'', //部门一级
        strDep2:'', //部门二级
        strDep3:'', //部门三级
        strservuserid:'',//客服
        strAchievedep:'',//归属业务部门
        strAchieveowner:'',//业务员
        strRecchannel:'',//招聘部门
        strRecsult:'',//招聘顾问
        strRecdep:'',//招聘渠道
        strcity:''//城市
      },
      // 表头
      tableTitle:[],
      tableHeight: 0,
      tableLoading: false,
      tableData: [],
      total: 0
    }
  },
  created() {
    this.rosterQuery.roletype = localStorage.loginRoletype
    this.rosterQuery.strorgancode = localStorage.gancode
    this.calHeight()
    this.rosterQuery = this.toChildrenData
    this.getTableTitle()
    // this.getList(this.rosterQuery)
    // console.log('height',this.rosterQuery)
  },
  methods: {
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
      // console.log('height',this.tableHeight)
    },
    //判断是否为空(包含0)
    isNullDate(o) {
      return (
        o == undefined ||
        o == "undefined" ||
        (o + "").indexOf("undefined") > -1 ||
        o == null ||
        o == "" ||
        o == "null" ||
        o == [] ||
        o == 0 ||
        o == "1900/01/01" ||
        o == "1900-01-01T00:00:00" ||
        o == "1900-01-01"
      )
    },
    // 提醒判断
    isOverdue(num, data, endDate){
      // let timeNow = moment().format("YYYY-MM-DD")
      // let timeEnd = moment(endDate).format("YYYY-MM-DD")
      if((Number(data) < num) && (Number(data) > 0)){
        return '还有' + data + '天到期'
      }
      if(Number(data) < 0){
        return '已过期'
      }
      // if(timeEnd == timeNow){
      //   return '已到期'
      // }
      if(Number(data) > num){
        return ''
      }
      if(Number(data) == 0){
        return ''
      }
    },
    // 获取列表表头
    getTableTitle(){
      xz.getJbPageColumnDefList('XZ_emp_UserBasenewout').then(res => {
        // console.log('表头', res)
        if (res.status == 'ok') {
          this.tableTitle = res.msg
          // this.getList(this.rosterQuery)
        } else {
          this.tableTitle = []
        }
      })
    },
    // 获取列表
    getList(query){
      this.tableLoading = true
      xz.getEmpBaseUsersLists(query).then(res => {
        // console.log('客户', res)
        if (res.status == 'ok') {
          this.tableData = res.msg
          this.total = res.totalcount
        } else {
          this.tableData = []
          this.total = 0
        }
        this.$emit('func', this.tableData)
        this.tableLoading = false
      })
    },
    //分页
    changeBPage(val){
      this.rosterQuery = this.toChildrenData
      this.rosterQuery.currpage = Number(val)
      this.getList(this.rosterQuery)
    },
    handleSizeChange(val) {
      this.rosterQuery = this.toChildrenData
      this.rosterQuery.currpage = 1
      this.rosterQuery.perpage = Number(val)
      this.getList(this.rosterQuery)
    }
  }
};
</script>
<style>
.p_ros_content .flname{
  text-align: right;
}
.p_ros_content .cus_dialog .el-select{
    width: 100%;
}
.p_ros_content .screenInput .el-select .el-input__inner {
    height: 40px;
    line-height: 40px;
}
.p_ros_content .screenInput .el-input{
    width: 200px;
}
</style>
<style scoped>
.el-pagination{
  background-color: #fff;
}
.reset{
  height: 32px;
  padding: 5px 15px;
  border-radius: 5px;
  color:#B2BCB7;
  background-color: #fff;
  border: 1px solid #fff;
  margin-right: 10px;
}
.p-txt{
  color: rgba(0, 0, 0, 0.4);
}
</style>